  // .00 を削除する関数
  function removeDecimalFromPrices() {
    document.querySelectorAll('.price-item').forEach(el => {
      const text = el.textContent;
      const match = text.match(/¥([\d,]+)\.00/);
      if (match) {
        el.textContent = `¥${match[1]}`;
      }
    });
  }

  // 商品カードのv-stackの高さを統一する関数（セクション別計算版）
  function alignProductCardVStacks() {
    const sections = document.querySelectorAll('section, .section');
    
    sections.forEach(section => {
      const productCards = section.querySelectorAll('.product-card');
      const vStacks = [];
      
      productCards.forEach(card => {
        const vStack = card.querySelector('.product-card__info > .v-stack');
        if (vStack && !vStack.dataset.heightCalculated) {
          vStacks.push(vStack);
        }
      });
      
      if (vStacks.length === 0) return;
      
      vStacks.forEach(vStack => {
        vStack.dataset.heightCalculated = 'true';
      });
      
      const originalHeights = new Map();
      vStacks.forEach(vStack => {
        originalHeights.set(vStack, vStack.style.minHeight);
        vStack.style.minHeight = '';
      });
      
      requestAnimationFrame(() => {
        let maxHeight = 0;
        
        vStacks.forEach(vStack => {
          const height = vStack.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
        
        vStacks.forEach(vStack => {
          vStack.style.minHeight = `${maxHeight}px`;
        });
        
        console.log(`セクション内のv-stack高さを統一しました: ${maxHeight}px`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 初回実行
    removeDecimalFromPrices();
    alignProductCardVStacks();

    // DOM変化を監視
    const observer = new MutationObserver((mutations) => {
      let hasNewProductCards = false;
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList && node.classList.contains('product-card')) {
                hasNewProductCards = true;
                break;
              }
              if (node.querySelector && node.querySelector('.product-card')) {
                hasNewProductCards = true;
                break;
              }
            }
          }
        }
      }
      
      removeDecimalFromPrices();
      
      if (hasNewProductCards) {
        alignProductCardVStacks();
      }
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });

  //PDFの外部リンク処理
function applyPdfExternalLinks(root = document) {
  const pdfPattern = /\.pdf(?:$|\?|#)/i;

  root.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href') || '';
    if (!pdfPattern.test(href)) return;

    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }
    if (!link.hasAttribute('rel')) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  removeDecimalFromPrices();
  alignProductCardVStacks();
  applyPdfExternalLinks();

  const observer = new MutationObserver(mutations => {
    let hasNewProductCards = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        applyPdfExternalLinks(node);

        if (node.classList?.contains('product-card') ||
            node.querySelector?.('.product-card')) {
          hasNewProductCards = true;
        }
      });
    });

    removeDecimalFromPrices();

    if (hasNewProductCards) {
      alignProductCardVStacks();
    }
  });

  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
});

/**
 * 配達料（ダミー商品）をカート内で1回だけ計上するための補正
 *
 * - Infinite Options等で line item properties に「23区内」等の値が入る前提
 * - 該当プロパティが1つでもあれば、配達料ダミー商品（variant_id指定）を1つだけ維持
 * - 該当プロパティが無ければ、配達料ダミー商品を削除
 *
 * NOTE:
 * - 配達料ダミー商品のプロパティは `_` で始めることで、テーマ側の表示（`snippets/line-item.liquid`）から隠れます。
 */
function setupDeliveryFeeDedupeOnCartPage() {
  const settings = window.themeVariables?.settings;
  if (!settings || settings.pageType !== 'cart') return;
  if (!settings.deliveryFeeDedupeEnabled) return;

  const propertyKey = (settings.deliveryFeeOptionPropertyKey ?? '').toString().trim();
  const debug = Boolean(settings.deliveryFeeDebug);
  const strictSinglePaidOption = Boolean(settings.deliveryFeeStrictSinglePaidOption);
  const proceedToCheckoutKey = '__delivery_fee_proceed_to_checkout_ts';

  const parseVariantId = (v) => {
    const n = parseInt((v ?? '').toString(), 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  // Paid dummy variants (configure in theme editor)
  // NOTE: setting keys are historical; even if price changed, just set the correct variant_id in the theme settings.
  const variantIdShibuya4400 = parseVariantId(settings.deliveryFeeVariantIdShibuya4400); // now used for +3300
  const variantId23ku11000 = parseVariantId(settings.deliveryFeeVariantId23ku11000);     // now used for +6600
  const variantIdOutside19800 = parseVariantId(settings.deliveryFeeVariantIdOutside19800);
  const variantIdNationwide6600 = parseVariantId(settings.deliveryFeeVariantIdNationwide6600);

  const configuredFeeVariantIds = [variantIdShibuya4400, variantId23ku11000, variantIdOutside19800, variantIdNationwide6600].filter(Boolean);
  if (configuredFeeVariantIds.length === 0) return;

  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const urlFor = (path) => `${root}${path.replace(/^\//, '')}`;

  const log = (...args) => {
    if (debug) console.log('[delivery-fee-dedupe]', ...args);
  };

  const normalize = (v) => (v ?? '').toString().trim();
  // Infinite Options の表記ゆれ（空白/括弧の有無など）を吸収するための正規化
  const normalizeForMatch = (v) => normalize(v)
    .replace(/\s+/g, '')      // whitespace
    .replace(/[()（）]/g, ''); // parentheses (half/full width)

  /**
   * オプション判定ルール
   *
   * 重要:
   * - "23区内" のような曖昧一致は避け、なるべく選択肢の文言に寄せた一致を使う
   * - 複数の有料が混在した場合は feeRank の最大を採用
   */
  const optionRules = [
    // Free
    { code: 'pickup', matchers: ['お持ち帰り'], feeVariantId: null, feeRank: 0 },

    // Paid (ranks reflect your price list: 19,800 > 6,600 > 3,300)
    {
      code: 'shibuya_3300',
      matchers: [
        '配達(渋谷区/港区/品川区/目黒区/大田区/新宿区)',
        '配達(渋谷区/港区/品川区/目黒区/大田区/新宿区)+3300円',
        '配達(渋谷区/港区/品川区/目黒区/新宿区)',
        '配達(渋谷区/港区/品川区/目黒区/新宿区)+3300円'
      ],
      feeVariantId: variantIdShibuya4400,
      feeRank: 1
    },
    {
      code: 'nationwide_6600',
      matchers: [
        '全国配送/BOX入り（200サイズ）',
        '全国配送/BOX入り(200サイズ)',
        '全国配送/BOX入り（200サイズ）+6,600円',
        '全国配送/BOX入り（200サイズ）+6600円'
      ],
      feeVariantId: variantIdNationwide6600,
      feeRank: 2,
      priority: 1
    },
    {
      code: '23ku_6600',
      matchers: [
        '配達(他23区内)',
        '配達(他23区内)+6600円',
        '配達(他23区内)+6,600円',
        '配達(23区内)',
        '配達(23区内)+6600円',
        '配達(23区内)+6,600円'
      ],
      feeVariantId: variantId23ku11000,
      feeRank: 2,
      priority: 2
    },
    {
      code: 'outside_19800',
      matchers: [
        '配達/23区外（横浜、川崎、千葉全域）',
        '配達・装飾/23区外（横浜、川崎、千葉全域）',
        '23区外（横浜、川崎、千葉全域）'
      ],
      feeVariantId: variantIdOutside19800,
      feeRank: 4,
      priority: 1
    }
  ].filter((r) => r.feeVariantId !== null ? Boolean(r.feeVariantId) : true);

  const findMatchesForItem = (item) => {
    const props = item?.properties || {};
    const values = propertyKey
      ? [normalizeForMatch(props[propertyKey])]
      : Object.entries(props).map(([, v]) => normalizeForMatch(v));

    const matched = [];
    for (const rule of optionRules) {
      const ruleMatchers = (rule.matchers || []).map((m) => normalizeForMatch(m));
      for (const v of values) {
        if (!v) continue;
        if (ruleMatchers.some((m) => m && v.includes(m))) {
          matched.push(rule);
          break;
        }
      }
    }
    return matched;
  };

  const fetchCart = async () => {
    const res = await fetch(urlFor('cart.js'), { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error(`Failed to fetch cart.js (${res.status})`);
    return await res.json();
  };

  const cartChange = async ({ key, quantity }) => {
    const res = await fetch(urlFor('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error(`Failed to change cart (${res.status})`);
    return await res.json();
  };

  const cartAdd = async ({ variantId, quantity, properties }) => {
    const res = await fetch(urlFor('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
            properties: properties || {}
          }
        ]
      })
    });
    if (!res.ok) throw new Error(`Failed to add to cart (${res.status})`);
    return await res.json();
  };

  let inFlight = false;
  let scheduled = null;

  const syncOnce = async () => {
    if (inFlight) return;
    inFlight = true;

    try {
      const cart = await fetchCart();

      const feeItemTitleMatchers = [
        '配達(渋谷区/港区/品川区/目黒区/大田区/新宿区)',
        '配達(渋谷区/港区/品川区/目黒区/新宿区)',
        '配達(23区内)',
        '配達(他23区内)',
        '配達/23区外（横浜、川崎、千葉全域）',
        '配達・装飾/23区外（横浜、川崎、千葉全域）',
        '全国配送/BOX入り（200サイズ）'
      ].map((m) => normalizeForMatch(m));

      const isLikelyFeeTitle = (item) => {
        const title = normalizeForMatch(item?.title);
        if (!title) return false;
        return feeItemTitleMatchers.some((m) => m && title.includes(m));
      };

      const isFeeItem = (item) => {
        const isAutoAdded = item?.properties?._auto_delivery_fee === '1';
        if (isAutoAdded) return true;

        // Safety: only treat configured variant IDs as fee items if the title also looks like a fee item.
        // This prevents accidental deletion when a real product variant_id is mistakenly entered in settings.
        const isConfiguredFeeVariant = configuredFeeVariantIds.includes(item.variant_id);
        return isConfiguredFeeVariant && isLikelyFeeTitle(item);
      };

      const feeItems = (cart.items || []).filter(isFeeItem);

      const matchedPaidRules = [];
      const matchedAnyRules = [];

      for (const item of (cart.items || [])) {
        if (isFeeItem(item)) continue;

        const matches = findMatchesForItem(item);
        for (const m of matches) {
          matchedAnyRules.push(m);
          if (m.feeVariantId) matchedPaidRules.push(m);
        }
      }

      // Choose the highest fee among paid selections (prevents double charging).
      // If feeRank ties (e.g., 19,800), prefer higher priority (e.g., decor_outside).
      const bestPaidRule = matchedPaidRules.reduce((best, cur) => {
        if (!best) return cur;
        if (cur.feeRank !== best.feeRank) return cur.feeRank > best.feeRank ? cur : best;
        const curP = cur.priority ?? 0;
        const bestP = best.priority ?? 0;
        return curP > bestP ? cur : best;
      }, null);

      const desiredFeeVariantId = bestPaidRule?.feeVariantId ?? null;

      const uniquePaidVariantIds = Array.from(new Set(matchedPaidRules.map((r) => r.feeVariantId).filter(Boolean)));
      const hasMixedPaidOptions = uniquePaidVariantIds.length > 1;

      log({
        desiredFeeVariantId,
        hasMixedPaidOptions,
        matched: matchedAnyRules.map((r) => r.code),
        feeItems: feeItems.map((i) => ({ key: i.key, qty: i.quantity, variant_id: i.variant_id }))
      });

      let didMutate = false;

      // Optional: block checkout if mixed paid options are present (helps catch inconsistent carts)
      const checkoutButton = document.querySelector('form.cart-page button[name="checkout"]');
      if (checkoutButton) {
        const shouldBlock = strictSinglePaidOption && hasMixedPaidOptions;
        checkoutButton.toggleAttribute('disabled', shouldBlock);
        checkoutButton.classList.toggle('btn-is-disabled', shouldBlock);
      }

      // 1) Remove fee items that are not the desired one (or remove all if none desired)
      for (const feeItem of feeItems) {
        if (!desiredFeeVariantId) {
          await cartChange({ key: feeItem.key, quantity: 0 });
          didMutate = true;
          continue;
        }

        if (feeItem.variant_id !== desiredFeeVariantId) {
          await cartChange({ key: feeItem.key, quantity: 0 });
          didMutate = true;
        }
      }

      if (desiredFeeVariantId) {
        // Safety: if the desired fee variant_id already exists in cart as a normal-looking product,
        // it's likely the settings are misconfigured (fee variant IDs set to real product IDs).
        const existingSameVariant = (cart.items || []).find((i) => i.variant_id === desiredFeeVariantId);
        if (existingSameVariant && !isFeeItem(existingSameVariant) && !isLikelyFeeTitle(existingSameVariant)) {
          log('abort: desired fee variant_id looks like a normal product. Check theme settings.', {
            desiredFeeVariantId,
            title: existingSameVariant.title
          });
          return { didMutate: false, aborted: true };
        }

        // Re-fetch cart state? keep it simple: operate on original feeItems but filtered to desired
        const desiredFeeItems = feeItems.filter((i) => i.variant_id === desiredFeeVariantId);

        if (desiredFeeItems.length === 0) {
          await cartAdd({
            variantId: desiredFeeVariantId,
            quantity: 1,
            properties: {
              _auto_delivery_fee: '1',
              _auto_delivery_fee_variant_id: String(desiredFeeVariantId)
            }
          });
          didMutate = true;
        } else {
          const [keep, ...remove] = desiredFeeItems;
          for (const feeItem of remove) {
            await cartChange({ key: feeItem.key, quantity: 0 });
            didMutate = true;
          }
          if (keep.quantity !== 1) {
            await cartChange({ key: keep.key, quantity: 1 });
            didMutate = true;
          }
        }
      }

      if (didMutate) {
        // cart page is server-rendered; reload to reflect updated lines/totals.
        window.location.reload();
        return { didMutate: true };
      }

      return { didMutate: false };
    } catch (e) {
      log('error', e);
      // fail open: do nothing (no reload)
      return { didMutate: false, error: e };
    } finally {
      inFlight = false;
    }
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = setTimeout(() => {
      scheduled = null;
      syncOnce();
    }, 150);
  };

  // Initial run
  scheduleSync();

  // Re-run when the theme updates cart via AJAX (quantity changes, remove, etc.)
  document.addEventListener('cart:change', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);

  /**
   * Checkoutクリック時に、必ず配達料ダミーの整合を取ってから遷移する
   * - 追加/削除が必要ならリロードが入るため、その後に自動でcheckoutへ進めるようにsessionStorageでフラグを保持
   */
  const cartForm = document.querySelector('form.cart-page');
  const checkoutButton = cartForm?.querySelector('button[name="checkout"]');

  const proceedTs = parseInt(sessionStorage.getItem(proceedToCheckoutKey) || '0', 10);
  const shouldAutoProceed = Number.isFinite(proceedTs) && proceedTs > 0 && (Date.now() - proceedTs) < 2 * 60 * 1000;

  if (cartForm && checkoutButton) {
    // If we reloaded while trying to proceed to checkout, finalize now (after sync)
    if (shouldAutoProceed) {
      setTimeout(async () => {
        const res = await syncOnce();
        if (res?.didMutate) return; // another reload may happen
        sessionStorage.removeItem(proceedToCheckoutKey);
        window.location.href = urlFor('checkout');
      }, 0);
    }

    checkoutButton.addEventListener('click', async (e) => {
      // If user clicks quickly after load, ensure sync happens before checkout
      e.preventDefault();
      sessionStorage.setItem(proceedToCheckoutKey, String(Date.now()));

      const res = await syncOnce();
      if (res?.didMutate) return; // reload will happen, auto proceed after reload

      sessionStorage.removeItem(proceedToCheckoutKey);
      window.location.href = urlFor('checkout');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setupDeliveryFeeDedupeOnCartPage();
});